import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { Bookmark_QB, Question_Bookmark, Report_Submit, Result_Submit } from "../../gql/mutation";
import { GET_Instrucation_QB, Get_test } from "../../gql/queries";
import moment from "moment";
import { getQbProgressPercentage } from "../../utils";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";

const INITIAL_STATE = {
    contentType: "",
    userFeedBack: "",
    category: "",
    contentId: ''
};
export default function QbAttempt() {
    let { id, name, indexs } = useParams()
    const navigate = useNavigate();
    let location = useLocation();
    const [config, setConfig] = useState();
    const [enable, setDisabled] = useState(true)
    const [hashconfig, setHashConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [index, setIndex] = useState(parseInt(indexs));
    const [data, setData] = useState(JSON.parse(location.state));
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getDetails, Details] = useState(INITIAL_STATE);
    const [infoShow, setInfo] = useState(false);
    const [imgPopup, setImgPopup] = useState(false);
    const [showImg, setShowImg] = useState();
    const infoDetailShow = () => setInfo(true);
    const infoDetailhide = () => setInfo(false);
    const REACT_APP_ImageURL = 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'
    const showPopupImg = (d) => {
        setImgPopup(true);
        setShowImg(d);
    };
    const imgHide = () => setImgPopup(false);
    const [report] = useMutation(Report_Submit)
    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'test' // Query name,

        ],
    });

    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function () {
            navigate(`/testlayer/viewallsolution/${id}`);
            window.history.pushState(null, null, window.location.href);

        };
    }, [navigate]);
    const [getBookmarkQuestion] = useMutation(Question_Bookmark, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'test' // Query name,

        ],
    });
    const query1 = useQuery(Get_test, {
        variables: {
            "_id": id,
        },
    });
    useEffect(() => {
        const getHashConfigData = async () => {
            try {
                const remoteData = await firebaseData('hashtag_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setHashConfig(JSON.parse(remoteData));
                // setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                // setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getHashConfigData();
        }
    }, []);
    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);
    if (query1.loading) { return (<><Loader /></>) }
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }
    let arr = []
    query1.data.test.progress.questions.map(obj => {
        if (obj.questionId === data[index]._id) {
            arr.push(obj.userAnswer)
        }
    })

    const pre = () => {
        if (index > 0) {
            let preIndex = index - 1
            setIndex(preIndex);
        }
    }
    const next = (index) => {
        if (index < data.length) {
            let nextIndex = index + 1
            setIndex(nextIndex);
        }
    }
    const copytext = async (e) => {
        navigator.clipboard.writeText(data && data[index].questionCode)
        toast.success('Copied Success')
    }

    const mantraCopyCode = async (e) => {
        navigator.clipboard.writeText(query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode)
        toast.success('Copied Success')
    }

    const handleInputChange = function (fieldValue, fieldName) {
        getDetails.contentType = "Test"
        Details({ ...getDetails, [fieldName]: fieldValue })
        if (!fieldValue) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        getDetails.contentId = data && data[index]._id
        getDetails.courseName = course?.preparingFor || ""
        if (getDetails.contentType === "Test") {
            getDetails.contentTypeCategory = query1.data?.test?.testName || ""
        }
        report({ variables: { addReportInput: getDetails } }).then(res => {
            if (res.data.addUserReport.userId) {
                Details(INITIAL_STATE)
                setInfo(false)
                toast.success('Report Successful Submitted')
            }
        }).catch(res => {
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
    }

    const questionImagePlaceholders = (htmlContent) => {
        if (htmlContent) {
            const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
            return modifiedHtmlContent;
        }

    };

    const removeImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };

    const questionoriginalHtml = data && data[index].question.questionText
    const questionmodifiedHtml = questionImagePlaceholders(questionoriginalHtml);

    const solutionoriginalHtml = data && data?.[index]?.solution?.solutionText
    let solutionmodifiedHtml
    if (solutionoriginalHtml) {
        solutionmodifiedHtml = removeImagePlaceholders(solutionoriginalHtml);
    }

    const idValuePairs = [];

    for (const id in hashconfig) {
        if (hashconfig.hasOwnProperty(id)) {
            const value = hashconfig[id];
            idValuePairs.push({ id, value });
        }
    }
    let arrData = []
    if (data?.[index] && data?.[index]?.tags && Array.isArray(data?.[index] && data?.[index]?.tags)) {
        data?.[index] && data?.[index]?.tags?.map(on => {
            idValuePairs?.map(o => {
                if (on == o?.id) {
                    // console.log(o.id)
                    arrData.push(o?.value)
                }

            })

        })
    }



    console.log(course, "Course");
    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        {/* <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/">QBank</a></li>
                    <li className="breadcrumb-item active">{data ? data.title : ""}</li> */}
                    </ul>
                </div>
                <section className="videoLayer_wrapper qbanks_wrapper testall_attempt_wrapper section_side_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="topics_wrapper_main">
                                <div className="subjects_wrapper topic_header">
                                    <div className="topic_header_content d-flex align-items-center">
                                        <div className="topic_image_ttl d-flex align-items-baseline">
                                            {/* <figure className="back_arrow" onClick={() => navigate(-1)}> */}
                                            <figure className="back_arrow">
                                                <Link to={`/testlayer/viewallsolution/${id}`}>
                                                    <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                </Link>
                                            </figure>
                                            <figure className="subject_inner_img">
                                                <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                                <span className="text_qb">QB</span>
                                            </figure>
                                            <div className="subject_ttl_detail qbanks_ttl_details">
                                                <h5>{query1.data ? query1.data.test.title : ""}</h5>
                                                <div className="help_wrapper d-flex align-items-center">
                                                    <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{data ? data.length : 0} Questions</span></p>
                                                    {
                                                        query1.data && query1.data.test.authorDetails &&
                                                        <p><span>Verified by</span> {query1.data && query1.data.test.authorDetails ? query1.data.test.authorDetails.name : ""}</p>
                                                    }
                                                    {
                                                        !query1.data.test.authorDetails &&
                                                        <p><span>Verified by</span> DBMCI Faculty</p>
                                                    }
                                                </div>
                                                <div className="bookmarks_share">
                                                    {
                                                        query1.data && query1.data.test.progress == null &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": false } })}>
                                                            <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                <div className="instruction_header d-flex align-items-center">
                                    <div className="attempt_ttl">
                                        <h6> Question {index + 1}</h6>
                                    </div>
                                    <div className="ttl_options">

                                        <span onClick={infoDetailShow}>
                                            <img src={Icons.Info} alt="share" className="img-fluid" />
                                        </span>
                                        {
                                            query1.data && query1.data.test.progress != null && !query1.data.test.progress.bookmarkedQids.includes(query1.data.test.questions[index]._id) &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId: data[index].topic ? data[index].topic : null, courseName: course.preparingFor, "status": true } })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                            query1?.data?.test?.progress != null && query1?.data?.test?.progress?.bookmarkedQids?.includes(query1?.data?.test?.questions?.[index]?._id) &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId: data[index].topic ? data[index].topic : null, courseName: course.preparingFor, "status": false } })}>
                                                <img src={Icons?.unBookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="instructions_details">
                                    <div className="questions_ttl">
                                        {questionmodifiedHtml ? <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6> : ""}

                                        <div className="ans_img_wrapper">
                                            {/* {
                                                data[index]?.question?.questionImage[0] &&
                                                <img src={data[index]?.question?.questionImage[0].includes('/') ? data[index].question.questionImage[0] : REACT_APP_ImageURL + data[index]?.question?.questionImage[0]} alt="" className="img-fluid" />
                                            }                                            
                                            {
                                                data[index]?.question?.questionImage[0] &&
                                                <figcaption className="img_fullscreen" onClick={() => showPopupImg(data[index]?.question?.questionImage[0].includes('/') ? data[index]?.question?.questionImage[0] : REACT_APP_ImageURL + data[index]?.question?.questionImage[0])}>
                                                    <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                </figcaption>
                                            } */}
                                            {!data?.[index]?.question?.questionVideo && data?.[index]?.question?.questionImage?.[0] && (
                                                <>
                                                    <img
                                                        src={data[index].question.questionImage[0].includes('/')
                                                            ? data[index].question.questionImage[0]
                                                            : REACT_APP_ImageURL + data[index].question.questionImage[0]}
                                                        alt=""
                                                        className="img-fluid"
                                                    />
                                                    <figcaption
                                                        className="img_fullscreen"
                                                        onClick={() => showPopupImg(
                                                            data[index].question.questionImage[0].includes('/')
                                                                ? data[index].question.questionImage[0]
                                                                : REACT_APP_ImageURL + data[index].question.questionImage[0]
                                                        )}
                                                    >
                                                        <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                    </figcaption>
                                                </>
                                            )}

                                        </div>
                                        {data?.[index]?.question?.questionVideo && (
                                            <div className="question_video_wrapper">
                                                <video
                                                    src={data[index].question.questionVideo}
                                                    controls
                                                    autoPlay
                                                    muted
                                                    playsInline
                                                    className="img-fluid"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <ul type="none" className="instruction_list">
                                        {
                                            data?.[index]?.options && data?.[index]?.options?.map((d, i) => (
                                                <>
                                                    <li className={((d._id == ((arr) ? arr : "")) ? (data[index] && data[index].answer[0]) == ((arr) ? arr : "") ? 'correct' : 'wrong' : (data[index] && data[index].answer[0]) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center">
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    {/* <p>{d.optionText}</p> */}
                                                                    <p dangerouslySetInnerHTML={{ __html: d?.optionText || "" }}></p>

                                                                </div>

                                                            </div>
                                                            {/* {
                                                            <div className="ques_percent">
                                                                <span>{data[index] ? Math.round((d.optionAttempt*100) / data[index].totalAttemptCount)>0?Math.round((d.optionAttempt*100) / data[index].totalAttemptCount):0 : 0}%</span>
                                                            </div>
                                                            } */}
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                        }
                                    </ul>
                                    {/* {
                                    
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(data[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(data[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                </div>
                                {
                                    <>
                                        <div className="recommended_video_wrapper answer_details_wrapper">
                                            {
                                                data[index].options.map((d, i) => (
                                                    data[index].answer[0] == d._id &&
                                                    <>
                                                        <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                        <h6>{data[index].answer[0] == d._id ? d.optionText : ''}</h6>
                                                    </>
                                                ))
                                            }
                                            <div className="ans_tags">
                                                {
                                                    arrData.map(i => (
                                                        <span>#{i}</span>
                                                    ))
                                                }
                                            </div>
                                            <div className="editor_data">
                                                <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                            </div>

                                            {
                                                data[index]?.solution?.solutionVideo &&
                                                <div className="solution_video_wrapper">
                                                    <video
                                                        src={data[index].solution.solutionVideo}
                                                        controls
                                                        autoPlay
                                                        muted
                                                        playsInline
                                                        className="img-fluid"
                                                        style={{ maxWidth: "100%", marginTop: "10px" }}
                                                    />
                                                </div>
                                            }

                                            {
                                                // data[index]?.solution?.solutionImage.map((o) => (
                                                //     <>
                                                //         <div className="ans_img_wrapper">
                                                //             <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                                //             <figcaption className="img_fullscreen" onClick={() => showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                //                 <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                //             </figcaption>
                                                //         </div>
                                                //     </>
                                                // ))
                                                !data[index]?.solution?.solutionVideo &&
                                                data[index]?.solution?.solutionImage
                                                    .filter(o => o && o.trim() !== '') // Filter out empty strings or strings with only whitespace
                                                    .map((o) => (
                                                        <div className="ans_img_wrapper" key={o}>
                                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                                            <figcaption className="img_fullscreen" onClick={() => showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                            </figcaption>
                                                        </div>
                                                    ))

                                            }

                                        </div>
                                        {
                                            data[index].elements.length != 0 &&
                                            <>
                                                {
                                                    data[index].elements.map((d, i) => (
                                                        <>
                                                            {
                                                                d.type == "highyeild" &&
                                                                <div className="high_yield_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#HighYield</h6>
                                                                        </div>
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                d.type == 'extraedge' &&
                                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="extraEdge_ttl">
                                                                            <h6>#ExtraEdge</h6>
                                                                        </div>
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                d.type == 'table' &&
                                                                <div className="high_yield_wrapper table_content_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#Table</h6>
                                                                        </div>
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                    </div>
                                                                </div>

                                                            }
                                                            {
                                                                d.type == 'random' &&
                                                                <div className="high_yield_wrapper table_content_wrapper">
                                                                    <div className="recommended_video_wrapper">
                                                                        <div className="high_yield_ttl">
                                                                            <h6>#Random</h6>
                                                                        </div>
                                                                        <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${d ? d.data : ""}` }}></div>
                                                                    </div>
                                                                </div>
                                                            }

                                                        </>
                                                    ))
                                                }
                                                {
                                                    query1.data?.test?.questions[index]?.pearls !== null && query1.data?.test?.questions[index]?.pearls?.length !== 0 &&
                                                    <div className="high_yield_wrapper mantra_content_wrapper">
                                                        <div className="recommended_video_wrapper">
                                                            <div className="mantra_hedr d-flex justify-content-between align-items-center">
                                                                <div className="high_yield_ttl">
                                                                    <h6>#Mantra</h6>
                                                                </div>
                                                                <div className="copy_code">
                                                                    <p onClick={() => mantraCopyCode()}>{query1.data?.test && query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode} <img src={Icons.Copy} alt="" className="img-fluid" /></p>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive" dangerouslySetInnerHTML={{ __html: `${query1.data?.test?.questions[index]?.pearls[0]?.description}` }}></div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        }
                                        <div className="recommended_video_wrapper qid_wrapper">
                                            <h5>Reference</h5>
                                            <p>{data[index].reference}</p>
                                        </div>
                                        <div className="recommended_video_wrapper qid_wrapper d-flex align-items-center">
                                            <div className="qid_ttl">
                                                <h6>QID:</h6>
                                            </div>
                                            <div className="qid_code text-center"  >
                                                <ToastContainer />
                                                <span  >{data[index].questionCode}</span>
                                                <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => copytext()} />
                                            </div>
                                        </div>

                                    </>
                                }

                                <div className="nexts_prevs_buttons d-flex align-items-center justify-content-between">
                                    {
                                        <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                    }
                                    {
                                        (index < data.length - 1) &&
                                        <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Modal
                show={infoShow}
                onHide={infoDetailhide}
                backdrop="static"
                className="detail_modal report_modal"
                centered
            >
                <ToastContainer />
                <form action="" onSubmit={(e) => { handleSubmit(e) }}>
                    <Modal.Header>
                        <Modal.Title>
                            <h4>Report Issue</h4>
                            <span className="cross_icon">
                                <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={infoDetailhide} />
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="rating_modal_body">
                            <div className="form-group">
                                <label htmlFor="">Issue Type</label>
                                <select name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'category')} value={getDetails.category ?? ''}>
                                    <option value=''>Please Select</option>
                                    {
                                        config && config?.qb_question?.categories?.map((d, i) => (
                                            <option value={d.category_name}>{d.category_name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Description</label>
                                <textarea name="" id="" rows="5" className="form-control" placeholder="Please add issue description here..." onChange={(e) => handleInputChange(e.target.value, 'userFeedBack')} value={getDetails.userFeedBack ?? ''}></textarea>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="rating_submit">
                            <button type="button" className="btn btn_theme btn_border" onClick={infoDetailhide}>Cancel</button>
                            <button type="submit" disabled={enable} className="btn btn_theme" >Submit</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={imgPopup}
                onHide={imgHide}
                backdrop="static"
                className="detail_modal modelImgPopup"
                centered
                size="lg"
            >
                <Modal.Body>
                    <div className="Img_wrapper">
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={imgHide} />
                        </span>
                        <div className="img_popup">
                            <img src={showImg} alt="Popup Image" />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}